import STATUSES from '@/constants/STATUSES';

const getters = {
  isLoading(state, getters, rootState) {
    return rootState.profile.loading || rootState.lookups.status === STATUSES.LOADING;
  },
};

const actions = {
  setLoading({ commit }, isLoading) {
    commit('profile/setLoading', isLoading);
  },
};

export default {
  namespaced: true,
  getters,
  actions,
};
